import { render, staticRenderFns } from "./NavTypeNavigationsTreeDialog.vue?vue&type=template&id=17239a5a&scoped=true"
import script from "./NavTypeNavigationsTreeDialog.vue?vue&type=script&lang=js"
export * from "./NavTypeNavigationsTreeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17239a5a",
  null
  
)

export default component.exports